import Item from './item';
import Icon from '../icon';

export default class ToggleItem extends Item {
  element() {
    const { tag } = this;
		let childObj = null;
		if (tag === 'sumlandscape' || tag === "sumportrait") {
			childObj = tag === 'sumlandscape'?"横向求和":"纵向求和";
		}else{
      if (tag === 'cellslash') {
        childObj = new Icon(tag, '-cellslash-icon-img');
      }else if (tag === 'cellimage') {
        childObj = new Icon(tag, '-cellimage-icon-img');
      }else if (tag === 'backgroundimage') {
        childObj = new Icon(tag, '-background-img');
      }else if (tag === 'pagemargin') {
        childObj = new Icon(tag, '-page-margin');
      }else if (tag === 'printconfig') {
        childObj = new Icon(tag, '-printconfig');
      }else if (tag === 'exportconfig') {
        childObj = new Icon(tag, '-exportconfig');
      }else{
        childObj = new Icon(tag);
      }
			
		}
    return super.element()
      .child(childObj)
      .on('click', () => this.click());
  }

  click() {
    this.change(this.tag, this.toggle());
  }

  setState(active) {
    this.el.active(active);
  }

  toggle() {
    return this.el.toggle();
  }

  active() {
    return this.el.hasClass('active');
  }
}
